import React from 'react';
import { Button, ControlLabel } from 'react-bootstrap';
import GroupIndividualsSelect from './GroupIndividualsSelect.jsx';

const StakeholderParticipants = (props) => {
  const { index, handleRemove, editing, stakeholder } = props;

  return stakeholder ? (
    <div className="m-b-20">
      <div className="flex m-b-12">
        <h3>
          <ControlLabel className="m-0">{index + 1}</ControlLabel>
        </h3>
        <div className="form-group flex-1 m-b-0 m-l-8">
          <input
            disabled
            type="text"
            className="form-control"
            value={
              stakeholder.archived
                ? `${stakeholder.name} (archived)`
                : stakeholder.name
            }
          />
        </div>
        <Button
          bsStyle="default"
          className="btn-delete m-l-8"
          onClick={() => handleRemove(stakeholder.id)}
        >
          Delete
        </Button>
      </div>

      <div className="m-l-18">
        <GroupIndividualsSelect {...props} editing={editing} />
      </div>
    </div>
  ) : null;
};

export default StakeholderParticipants;
